import { DialogModule } from '@angular/cdk/dialog';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@card-software/library';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
const components = [
  DragDropModule,
  DialogModule,
  MatAutocompleteModule,
  MatCardModule,
  MatDialogModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatTooltipModule,
  MatExpansionModule,
  MatSlideToggleModule,
];

@NgModule({
  imports: [...components],
  exports: [...components],
  declarations: [],
  providers: [],
})
export class AngularMaterialModule {}
